import { ApiOption } from '../types/ApiOption';

export const apiOptions: ApiOption[] = [
  {
    id: 'anthropic',
    label: 'Anthropic',
    model: 'Claude',
  },
  {
    id: 'openai',
    label: 'OpenAI',
    model: 'GPT',
  },
];
